module.exports = __webpack_public_path__ + "assets/alerts/alarm-99dc4226030dc3bd1e304626f764ad2d.png";